module.exports = __webpack_public_path__ + "static/media/9DESA26.3fb52ab0.jpg";